import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1561">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1562">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1563">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1564">
          {isOpen ? <XIcon size={24} data-id="element-1565" /> : <PlusIcon size={24} data-id="element-1566" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1567">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-1568">
          {answer}
        </p>
      </div>
    </div>;
}
export function LHFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'Does Laser Hair Removal Hurt?',
    answer: 'Patients may experience a mild discomfort often described as a snapping or tingling sensation. Many modern laser devices include cooling mechanisms to enhance comfort during the procedure.'
  }, {
    question: 'How Many Sessions Are Needed?',
    answer: 'The number of sessions varies based on factors like hair color, thickness, and the targeted area. Multiple sessions, typically spaced a few weeks apart, are required to achieve optimal and long-lasting results. Most people see some results immediately, with a 10-25% reduction in hair after the first session.'
  }, {
    question: 'What Should I Expect After Treatment?',
    answer: 'After treatment patients are instructed to avoid sun exposure, take cool showers and avoid topical products. You may otherwise return to normal immediately after treatment.'
  }, {
    question: 'Are Laser Hair Reduction Results Permanent?',
    answer: 'Laser hair reduction offers long-lasting results, but it is not always permanent. Maintenance sessions may be needed over time to address any regrowth.'
  }];
  return <section className="bg-[#ECECEC] pt-[60px] pb-[60px] lg:pb-[100px]" data-id="element-1569">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1570">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1571">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1572">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1573"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-1574">
          <div className="space-y-2" data-id="element-1575">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-1576" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}